module.exports = __webpack_public_path__ + "img/16.92d0a501.jpg";